import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { ElementAction } from '../../../elements/elementAction';
import { ContentPlanRootState as S } from '../../../elements/contentPlan/store';
import { Functions } from '../../../types/types';
import { Metadata } from '../../../types/Metadata';
import { resetViewCheckbox } from '../viewReducer';
import { reloadData } from '../viewActions';

const addBackTags =
  (refIds: string[], data: Metadata): ElementAction<Functions, S> =>
  async (dispatch, getState, { getAPI }) => {
    const { addBackTags } = getAPI();
    await addBackTags({ refIds, data });
    dispatch(resetViewCheckbox());
    dispatch(reloadData(true, true));
  };

export const useActions = () => {
  const dispatch: Dispatch<any> = useDispatch();
  return {
    addBackTags: async (itemRefIds: string[], data: Metadata) =>
      dispatch(addBackTags(itemRefIds, data))
  };
};
